import React from 'react'
import { withRouter, Link } from 'react-router-dom'
import { Tabs, Descriptions, message } from 'antd'
import { reqOrganism } from '../../api'

import './organism.css'

const { TabPane } = Tabs

class Organism extends React.Component {
    state = {
        organism: {
            abbreviation: '',
            genus: '',
            cultivar: '',
            common_name: '',
            description: '',
            cross_reference: '',
            publication: '',
            analysis: []
        }
    }

    async componentDidMount() {
        const organism = this.props.match.params.organism
        const result = await reqOrganism(organism)

        if (result.code === 0) {
            this.setState({organism: result.data})
        } else {
            message.error('Request failed. ' + result.message)
        }
    }

    render() {
        const { abbreviation, genus, cultivar, common_name, description, cross_reference, publication, analysis } = this.state.organism
        let analysis_name = ''
        let analysis_desc = ''
        let analysis_program_name = ''
        let analysis_program_version = ''
        let analysis_date_performed = ''
        if (analysis.length > 0) {
            analysis_name = analysis[0].name
            analysis_desc = analysis[0].description
            analysis_program_name = analysis[0].program_name
            analysis_program_version = analysis[0].program_version
            analysis_date_performed = analysis[0].date_performed
        }
        return (
            <Tabs tabPosition='left' className="organism-content">
                <TabPane tab="Summary" key="summary">
                    <Descriptions column={1} bordered>
                        <Descriptions.Item label="Resource Type">Organism</Descriptions.Item>
                        <Descriptions.Item label="Abbreviation">{abbreviation}</Descriptions.Item>
                        <Descriptions.Item label="Genus">{genus}</Descriptions.Item>
                        <Descriptions.Item label="Cultivar">{cultivar}</Descriptions.Item>
                        <Descriptions.Item label="Common Name">{common_name}</Descriptions.Item>
                        <Descriptions.Item label="Description">{description}</Descriptions.Item>
                    </Descriptions>
                </TabPane>
                <TabPane tab="Analysis" key="analysis">
                    <Descriptions column={1} bordered>
                        <Descriptions.Item label="Name">
                            {analysis_name}
                        </Descriptions.Item>
                        <Descriptions.Item label="Program Name">
                            {analysis_program_name}
                        </Descriptions.Item>
                        <Descriptions.Item label="Program Version">
                            {analysis_program_version}
                        </Descriptions.Item>
                        <Descriptions.Item label="Date Performed">
                            {analysis_date_performed}
                        </Descriptions.Item>
                        <Descriptions.Item label="Description">
                            {analysis_desc}
                        </Descriptions.Item>
                    </Descriptions>
                </TabPane>
                <TabPane tab="Publication" key="publication">
                    <Descriptions column={1} bordered>
                        <Descriptions.Item label="Publication">
                            {publication}
                        </Descriptions.Item>
                    </Descriptions>
                </TabPane>
                <TabPane tab="Cross Reference" key="cross_reference">
                    <Descriptions column={1} bordered>
                        <Descriptions.Item label="Cross Reference">
                            <Link to={cross_reference}>{cross_reference}</Link>
                        </Descriptions.Item>
                    </Descriptions>
                </TabPane>
            </Tabs>
        )
    }
}

export default withRouter(Organism)
